import { Link } from "@tanstack/react-router";

import { useTerminology } from "../lib/terminology.js";

/** The 404 body; also stands in for a page whose feature the tenant has switched off. */
export function NotFound() {
  const { box } = useTerminology();
  return (
    <div className="py-16 text-center">
      <h1 className="font-body text-heading-h1 text-text-primary">Page not found</h1>
      <p className="mt-2 font-body text-body-b2 text-text-secondary">
        <Link to="/boxes" className="underline">
          Back to the {box.plural}
        </Link>
      </p>
    </div>
  );
}
